"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
exports.__esModule = true;
exports.GoalAnalysisComponent = void 0;
var angular = require("angular");
var basic_chart_component_1 = require("../basic-component/basic-chart.component");
var goal_analysis_chart_1 = require("./goal-analysis.chart");
var portfolio_uncertainty2_chart_1 = require("../portfolio-uncertainty2/portfolio-uncertainty2.chart");
var COMPONENT_NAME = 'smartorg.r6.acts.goalAnalysis';
require('./goal-analysis.component.css');
function removeGroupByFromReportOptions(reportOptions) {
    if (reportOptions.groupKey) {
        delete reportOptions.groupKey;
        delete reportOptions.groupByList;
    }
    return reportOptions;
}
var GoalAnalysisComponent = /** @class */ (function (_super) {
    __extends(GoalAnalysisComponent, _super);
    function GoalAnalysisComponent($scope, $timeout) {
        var _this = 
        // This constructor is necessary for inject scope and timeout.
        _super.call(this, $scope, $timeout, 'GoalAnalysis') || this;
        var ctrl = _this;
        ctrl.showAlert = function (type, title, message) {
            $scope.$emit('workbench:alert', { type: type, title: title, message: message });
        };
        _this.orientation = 'vertical';
        _this.chartInverted = true;
        $scope.$on('command:GOAL_ANALYSIS', function (event, args) {
            ctrl.initComponent(event, args);
            ctrl.menu = ctrl.getMenu();
            ctrl.menu.forEach(function (menuItem) {
                if (menuItem['name'] == 'Display') {
                    menuItem['items'].push({
                        'name': 'Rotate Goal Analysis Chart',
                        'callback': function () {
                            ctrl.rotateChart();
                        }
                    });
                }
            });
        });
        return _this;
    }
    GoalAnalysisComponent.prototype.rotateChart = function () {
        this.orientation = this.orientation === 'horizontal' ? 'vertical' : 'horizontal';
        this.chartInverted = this.orientation !== 'horizontal';
        this.drawAnalysisChart();
    };
    GoalAnalysisComponent.prototype.initComponent = function (event, args) {
        var ctrl = this;
        ctrl.actionMenuItem = args.actionMenuItem;
        ctrl.currentNode = args.node;
        ctrl.siblingNode = args.compareToNode;
        ctrl.settings = (0, basic_chart_component_1.loadSettings)(args.treeName, args.config.data.settings);
        ctrl.settings.currentFit = 'Monte Carlo';
        ctrl.isDirty = false;
        ctrl.errorMessage = '';
        ctrl.analyzing = false;
        if (ctrl.showTableOnReload &&
            (ctrl.actionMenuItem == ctrl.actionMenuItemOnReload)) {
            ctrl.settings.showTable = ctrl.showTableOnReload;
        }
        ctrl.menu = ctrl.getMenu();
        ctrl.tableData = {
            inputData: null,
            settings: ctrl.settings,
            mainNodeName: args.node.name,
            siblingNodeName: args.compareToNode ? args.compareToNode.name : null,
            reportOptions: removeGroupByFromReportOptions(args.reportOptions),
            excludeFilters: args.excludeFilters
        };
        ctrl.legends = {
            legends: args.config.data.legends,
            siblingLegends: args.config.data.siblingLegends
        };
        var _a = args.config.data.data, RollupKeys = _a.RollupKeys, Source = _a.Source, MVSType = _a.MVSType, rangeInfo = _a.rangeInfo;
        ctrl.menuInfo = { RollupKeys: RollupKeys, Source: Source, MVSType: MVSType };
        ctrl.analyzeOn = rangeInfo.analyzeOn;
        ctrl.lowerBound = rangeInfo.analyzeOn == 'prob' ? rangeInfo.rangeLow * 100 : rangeInfo.rangeLow * 1;
        ctrl.upperBound = rangeInfo.analyzeOn == 'prob' ? rangeInfo.rangeHigh * 100 : rangeInfo.rangeHigh * 1;
        ctrl.copyRangeInfoToOrig();
        ctrl.graphs = args.config.data.data.DataForEachKey;
        if (ctrl.graphs && ctrl.graphs.length) {
            if (ctrl.selectedGraph) {
                var graphName_1 = ctrl.selectedGraph.Title;
                ctrl.selectedGraph = ctrl.graphs.find(function (item) { return item.Title === graphName_1; }) || ctrl.graphs[0];
            }
            else {
                ctrl.selectedGraph = ctrl.graphs[0];
            }
            ctrl.drawChart();
        }
        ctrl.updateGoalReferences();
        ctrl.$timeout();
    };
    GoalAnalysisComponent.prototype.updateGoalReferences = function () {
        var ctrl = this;
        ctrl.goalUnits = ctrl.analyzeOn === 'prob' ? '%' : ctrl.selectedGraph.Units;
        if (ctrl.selectedGraph.cdfData) {
            ctrl.goalMin = ctrl.analyzeOn === 'prob' ? 0 : ctrl.selectedGraph.cdfData.main[0].valueRange.min;
            ctrl.goalMax = ctrl.analyzeOn === 'prob' ? 100 : ctrl.selectedGraph.cdfData.main[0].valueRange.max;
        }
    };
    GoalAnalysisComponent.prototype.getChartOptions = function (graph, options) {
        return (0, portfolio_uncertainty2_chart_1.getChartOptions)(graph, options);
    };
    GoalAnalysisComponent.prototype.onGoalInputsChange = function (field) {
        if (field === 'type') {
            this.updateGoalReferences();
            this.lowerBound = null;
            this.upperBound = null;
        }
        this.isDirty = this.origAnalyzeOn !== this.analyzeOn ||
            this.origLowerBound !== this.lowerBound ||
            this.origUpperBound !== this.upperBound;
    };
    GoalAnalysisComponent.prototype.checkGoalIsValid = function () {
        var ctrl = this;
        var errorMessage = '';
        if (typeof ctrl.lowerBound !== "number" && typeof ctrl.upperBound !== "number") {
            errorMessage = "Please input valid goal value.";
        }
        else if (typeof ctrl.lowerBound === "number" && typeof ctrl.upperBound === "number") {
            if (ctrl.lowerBound < 0 || ctrl.upperBound < 0) {
                errorMessage = "Goal value should not be smaller than zero.";
            }
            else if (ctrl.upperBound < ctrl.lowerBound) {
                errorMessage = "Max value should not be smaller than min value.";
            }
        }
        else if (typeof ctrl.lowerBound !== "number") {
            ctrl.lowerBound = ctrl.upperBound;
        }
        else {
            ctrl.upperBound = ctrl.lowerBound;
        }
        ctrl.errorMessage = errorMessage;
        return errorMessage === '';
    };
    GoalAnalysisComponent.prototype.analyzeWithGoalRange = function () {
        var ctrl = this;
        if (!ctrl.checkGoalIsValid()) {
            return;
        }
        var rangeInfo = ctrl.generateRangeInfo(ctrl.analyzeOn, ctrl.lowerBound, ctrl.upperBound);
        ctrl.updateCDFPlotBands(rangeInfo);
        var nodeID = ctrl.currentNode._id;
        ctrl.analyzing = true;
        ctrl.smartorg.performGoalAnalysis(nodeID, btoa(JSON.stringify(rangeInfo)), btoa(JSON.stringify(ctrl.tableData.reportOptions)), ctrl.tableData.excludeFilters, null, btoa(JSON.stringify(ctrl.menuInfo))).then(function (res) {
            ctrl.isDirty = false;
            ctrl.analyzing = false;
            ctrl.copyRangeInfoToOrig();
            ctrl.saveGoalAnalysisInfoInLocalStorage();
            ctrl.updateGraphs(res.data.data.DataForEachKey);
            ctrl.$scope.$apply();
        })["catch"](function (err) {
            ctrl.analyzing = false;
            ctrl.showAlert('danger', 'Analysis failed for ' + err.status, err.message);
        });
    };
    GoalAnalysisComponent.prototype.updateCDFPlotBands = function (rangeInfo) {
        var analyzeOn = rangeInfo.analyzeOn, lowerBound = rangeInfo.lowerBound, upperBound = rangeInfo.upperBound;
        var cdfChart = $('#chartContainer').highcharts();
        if (typeof cdfChart !== 'undefined') {
            cdfChart.xAxis[0].removePlotBand('plot-band-xAxis');
            cdfChart.yAxis[0].removePlotBand('plot-band-yAxis');
            var plotBandAxis = analyzeOn === 'prob' ? 'yAxis' : 'xAxis';
            cdfChart[plotBandAxis][0].addPlotBand({
                from: lowerBound,
                to: upperBound,
                color: '#FFFF8F',
                id: 'plot-band-' + plotBandAxis
            });
        }
    };
    GoalAnalysisComponent.prototype.updateCDFMeanPlotLines = function (meanValue) {
        var cdfChart = $('#chartContainer').highcharts();
        var decimals = this.settings.decimals, units = this.selectedGraph.Units;
        if (typeof cdfChart !== 'undefined') {
            // Update xAxis plot line for mean value
            cdfChart.xAxis[0].removePlotLine('plot-line-mean');
            cdfChart.xAxis[0].addPlotLine({
                value: meanValue,
                width: 2,
                color: '#379191',
                id: 'plot-line-mean',
                label: {
                    text: 'Goal range mean: ' + meanValue.toFixed(decimals) + ' ' + units,
                    verticalAlign: 'bottom',
                    textAlign: 'left',
                    x: 10,
                    y: -150,
                    rotation: 0,
                    style: {
                        color: '#379191',
                        fontWeight: 'bold'
                    }
                },
                zIndex: 5
            });
        }
    };
    GoalAnalysisComponent.prototype.getMeanValue = function () {
        var ctrl = this;
        var meanValue = ctrl.selectedGraph.analysisData.mean.toFixed(ctrl.settings.decimals) + " " + ctrl.selectedGraph.Units;
        return meanValue;
    };
    GoalAnalysisComponent.prototype.generateRangeInfo = function (analyzeOn, low, high) {
        var lowerBound = low;
        var upperBound = high;
        if (lowerBound == upperBound) {
            var bias = 0.001 * (this.goalMax - this.goalMin);
            lowerBound -= bias;
            upperBound += bias;
        }
        if (analyzeOn === 'prob') {
            lowerBound = lowerBound / 100.0;
            upperBound = upperBound / 100.0;
        }
        return { analyzeOn: analyzeOn, lowerBound: lowerBound, upperBound: upperBound };
    };
    GoalAnalysisComponent.prototype.saveGoalAnalysisInfoInLocalStorage = function () {
        var goalAnalysisInfo = {};
        if (localStorage.getItem('GoalAnalysisInfo')) {
            goalAnalysisInfo = JSON.parse(localStorage.getItem('GoalAnalysisInfo'));
        }
        var nodeID = this.currentNode._id;
        goalAnalysisInfo[nodeID] = this.generateRangeInfo(this.origAnalyzeOn, this.origLowerBound, this.origUpperBound);
        localStorage.setItem('GoalAnalysisInfo', JSON.stringify(goalAnalysisInfo));
    };
    GoalAnalysisComponent.prototype.copyRangeInfoToOrig = function () {
        this.origAnalyzeOn = this.analyzeOn;
        this.origLowerBound = this.lowerBound;
        this.origUpperBound = this.upperBound;
    };
    GoalAnalysisComponent.prototype.resetGoalInputs = function () {
        this.analyzeOn = this.origAnalyzeOn;
        this.lowerBound = this.origLowerBound;
        this.upperBound = this.origUpperBound;
    };
    GoalAnalysisComponent.prototype.updateGraphs = function (analysisGraphs) {
        var _loop_1 = function (graph) {
            var matchedGraph = analysisGraphs.find(function (g) { return g.Key === graph.Key; });
            if (matchedGraph) {
                graph.analysisData = matchedGraph.analysisData;
            }
        };
        for (var _i = 0, _a = this.graphs; _i < _a.length; _i++) {
            var graph = _a[_i];
            _loop_1(graph);
        }
        this.drawAnalysisChart();
        this.drawChart();
    };
    GoalAnalysisComponent.prototype.selectGraph = function () {
        if (this.isDirty) {
            this.resetGoalInputs();
            this.isDirty = false;
        }
        this.drawChart();
    };
    ;
    GoalAnalysisComponent.prototype.drawChart = function () {
        var ctrl = this;
        var graphData = JSON.parse(JSON.stringify(ctrl.selectedGraph.cdfData)) || [];
        var chartOptions = ctrl.getChartOptions(graphData, {
            currentNode: ctrl.currentNode,
            chartTitle: ctrl.actionMenuItem,
            legends: ctrl.legends,
            settings: ctrl.settings,
            timestamp: '-'
        });
        (0, basic_chart_component_1.makeChart)(chartOptions, ctrl.getAdditionalChartCallback());
        ctrl.probabilityFound = (0, goal_analysis_chart_1.findYOnLine)(chartOptions.series[1].data, ctrl.selectedGraph.analysisData.mean).toFixed(this.settings.decimals);
        if (!ctrl.isDirty && ctrl.selectedGraph.analysisData) {
            ctrl.drawAnalysisChart();
            var rangeInfo = ctrl.generateRangeInfo(ctrl.origAnalyzeOn, ctrl.origLowerBound, ctrl.origUpperBound);
            ctrl.updateCDFPlotBands(rangeInfo);
        }
        // else if (typeof $('#boxPlotChartContainer').highcharts() !== 'undefined'){
        //     $('#boxPlotChartContainer').highcharts().destroy();
        // }
    };
    GoalAnalysisComponent.prototype.drawAnalysisChart = function () {
        var boxPlotGraphData = JSON.parse(JSON.stringify(this.selectedGraph.analysisData)) || [];
        this.updateCDFMeanPlotLines(this.selectedGraph.analysisData.mean);
        this.tableData.inputData = boxPlotGraphData;
        this.tableData = JSON.parse(JSON.stringify(this.tableData));
        var timestamp = this.settings.timestampMode === 'lastRecalc' ? (0, basic_chart_component_1.getDate)(this.currentNode.lastRecalc) : (0, basic_chart_component_1.getDate)();
        var chartOptions = (0, goal_analysis_chart_1.getAnalysisChartOptions)(boxPlotGraphData, {
            currentNode: this.currentNode,
            legends: this.legends,
            settings: this.settings,
            timestamp: timestamp,
            chartInverted: this.chartInverted
        });
        (0, basic_chart_component_1.makeChart)(chartOptions, this.getAdditionalChartCallback());
    };
    GoalAnalysisComponent = __decorate([
        (0, basic_chart_component_1.Component)({
            bindings: {
                smartorg: '=',
                menu: '='
            },
            template: require("./goal-analysis.component.html")
        }),
        __metadata("design:paramtypes", [Object, Object])
    ], GoalAnalysisComponent);
    return GoalAnalysisComponent;
}(basic_chart_component_1.BasicChartComponent));
exports.GoalAnalysisComponent = GoalAnalysisComponent;
angular.module('smartorg.r6.acts.goalAnalysis', []).component('goalAnalysis', GoalAnalysisComponent);
module.exports = 'smartorg.r6.acts.goalAnalysis';
//# sourceMappingURL=goal-analysis.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/goal-analysis/goal-analysis.component.js